import React from 'react';

/* 권한 목록을 카테고리(perm.category)별로 묶어 보여 준다. 회원 등록·회원 상세·권한 그룹 상세가 같이 쓴다.
 * permissions: [{ id, name, category }] — 카테고리가 없으면 etcLabel 로 묶는다. 비어 있으면 emptyLabel. */
export const groupByCategory = (permissions, etcLabel) => (permissions || []).reduce((acc, perm) => {
  const category = perm.category || etcLabel;
  if (!acc[category]) acc[category] = [];
  acc[category].push(perm);
  return acc;
}, {});

function PermissionTree({ permissions, etcLabel, emptyLabel }) {
  if (!permissions || permissions.length === 0) {
    return <div className="mg-perm-empty">{emptyLabel}</div>;
  }
  return (
    <div className="mg-perm-tree">
      {Object.entries(groupByCategory(permissions, etcLabel)).map(([category, perms]) => (
        <div key={category} className="mg-perm-group">
          <div className="mg-perm-head">
            <span className="material-symbols-outlined">folder</span>
            {category}
            <span className="mg-perm-count">({perms.length})</span>
          </div>
          <div className="mg-perm-items">
            {perms.map((perm) => (
              <div key={perm.id} className="mg-perm-item">
                <span className="material-symbols-outlined">check</span>
                {perm.name}
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}

export default PermissionTree;
